import React from 'react';
import Icon from '../../../../components/AppIcon';

const SystemStatusIndicator = ({ status }) => {
  const statusConfig = {
    online: {
      color: 'text-success',
      bgColor: 'bg-success/10',
      icon: 'CheckCircle2',
      label: 'Voice Assistant Ready',
      description: 'All systems operational'
    },
    offline: {
      color: 'text-error',
      bgColor: 'bg-error/10',
      icon: 'XCircle',
      label: 'Voice Assistant Offline',
      description: 'Please check your connection'
    },
    maintenance: {
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      icon: 'AlertTriangle',
      label: 'System Maintenance',
      description: 'Limited functionality available'
    }
  };

  const config = statusConfig?.[status] || statusConfig?.online;

  return (
    <div className={`${config?.bgColor} border border-border rounded-lg p-4`}>
      <div className="flex items-center gap-3">
        <div className="relative">
          <Icon name={config?.icon} size={20} color={`var(--color-${status === 'online' ? 'success' : status === 'offline' ? 'error' : 'warning'})`} />
          {status === 'online' && (
            <span className="absolute -top-1 -right-1 w-2 h-2 bg-success rounded-full animate-pulse" />
          )}
        </div>
        <div className="flex-1">
          <div className={`text-sm font-medium ${config?.color}`}>
            {config?.label}
          </div>
          <div className="text-xs text-muted-foreground">
            {config?.description}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemStatusIndicator;